import { Component, OnInit, Renderer2 } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { environment } from "../../environments/environment";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AbstractComponent } from "./abstract/abstract.component";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { Router } from "@angular/router";
import { HeaderComponent } from "./incs/header.component";

@Component({
    selector: "kilowant-privacy-policy",
    templateUrl: "../../html/main-privacy-policy.html",
    imports: [HeaderComponent]
})
export class PrivacyPolicyComponent extends AbstractComponent {
    opened: number[] = [];

    constructor(
      router: Router, 
      route: ActivatedRoute, 
      analyticsService: AnalyticsService,
      generalService: GeneralService, 
      private renderer: Renderer2,
      dialog: MatDialog) {
       super(router, route, dialog, analyticsService, generalService);
       this.renderer.addClass(document.body, "forgotComp");
    }

    getBaseLink(): string {
      return this.router.url.split("#")[0];
    }

    ngOnDestroy() {
      this.renderer.removeClass(document.body, "forgotComp");
    }

    ngOnInit(): void {
       this.analyticsService.trackEvent("Privacy Policy Page", "User Opens Privacy Policy Page", "OPEN_PAGE");      
    }

    openClose(i: number): void {
       if (this.opened.includes(i)) {
          this.opened.splice(this.opened.indexOf(i), 1);
       } else {
          this.opened[this.opened.length] = i;
       }
    }
}